module.exports = __webpack_public_path__ + "img/capa_38.e72d86c2.png";